module.exports = __webpack_public_path__ + "static/media/facebook.0b6779a5.svg";